__turbopack_context__.v({
  "heightLightText": "index-module-scss-module__WuYU9G__heightLightText",
});
